import { Link } from "react-router-dom";
import {
  Briefcase,
  PieChart,
  Cpu,
  Gem,
  Rocket,
  Landmark,
  Calculator,
  Receipt,
  Banknote,
  TrendingUp,
  Building2,
  BadgeCheck,
  Shield,
  GraduationCap,
  Users,
  Building,
  ArrowUpRight,
} from "lucide-react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import { SERVICES } from "../../data/content";
import "./ServicesPage.css";

const ICONS = {
  Briefcase,
  PieChart,
  Cpu,
  Gem,
  Rocket,
  Landmark,
  Calculator,
  Receipt,
  Banknote,
  TrendingUp,
  Building2,
  BadgeCheck,
  Shield,
  GraduationCap,
  Users,
  Building,
};

export default function ServicesPage() {
  return (
    <div className="services-page">
      <PageHero
        badge="Services"
        title="Everything finance. One trusted desk."
        subtitle="Investment products, business finance, tax, compliance, and insurance — research-led services for individuals, SMEs, and growing enterprises."
        actions={[
          { label: "Book Consultation", to: "/contact", primary: true },
          { label: "Business Solutions", to: "/business-services" },
        ]}
      />

      <section className="pm-section services-grid-section">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            Full Suite
          </span>
          <h2 className="pm-section-title">Our services</h2>
          <p className="pm-section-sub">
            Choose a service to learn more, or book a consultation to map the
            right mix for your goals.
          </p>

          <div className="services-grid">
            {SERVICES.map((s) => {
              const Icon = ICONS[s.icon] || Briefcase;
              return (
                <article key={s.slug} className="pm-card services-card" id={s.slug}>
                  <div className="services-card__icon">
                    <Icon size={22} />
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <div className="services-card__actions">
                    <Link to={s.href} className="pm-btn pm-btn-ghost services-card__btn">
                      Learn More
                      <ArrowUpRight size={15} />
                    </Link>
                    <Link to="/contact" className="pm-btn pm-btn-outline services-card__btn">
                      Book Consultation
                    </Link>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBand
        title="Not sure where to begin?"
        subtitle="Book a free consultation — we'll recommend the right services for your stage and risk profile."
        primary={{ label: "Book Free Consultation", to: "/contact" }}
        secondary={{ label: "Talk to an Expert", to: "/contact" }}
      />
    </div>
  );
}
